import React from 'react';

import {
    Grid,
    PageHeader,
    Row,
    Col,
} from 'react-bootstrap';



export default function Introduction() {
    return <div>
        <Grid>
            <PageHeader>
                Components of the Blockchain
            </PageHeader>
            <Row>
                <Col>
                    <p>This is an interactive tool demonstrating the various building blocks of bitcoin, ethereum, open timestamps, and other blockchain-based technologies.</p>
                    <p>Select a tab above to begin.</p>
                </Col>
            </Row>
        </Grid>
    </div>;
}






// WEBPACK FOOTER //
// ./src/components/Introduction.js